import React from "react";
import { kindFood } from "../assetss/data/kindFood";
import KindFoodCardDetails from "./KindFoodCardDetails";
import { Link } from "react-router-dom";

const KindFoodCard = ({searchQuery}) => {
  return (
      <div className="kind-food  grid grid-cols-2 gap-2  mt-8  ">
        {kindFood.map((kind) => {
          return <KindFoodCardDetails searchQuery={searchQuery} kind={kind} key={kind.id} />;
        })}
      </div>
  );
};

export default KindFoodCard;
